import { useCallback, useEffect, useState } from 'react';
import { RESPONSE_STATUS } from '../../constnats/general';
import { TaskIdType, TaskExecutionInfoType } from '../../schemas/task.schemas';
import Alert from '../../utils/alert';
import TasksRepo from '../../utils/repository/tasksRepo/tasksRepo';

function useTaskExecutions(taskId: TaskIdType | undefined) {
    const [executions, setExecutions] = useState<TaskExecutionInfoType[]>([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    const fetchExecutions = useCallback(() => {
        if (!taskId) {
            return;
        }
        setLoading(true);
        TasksRepo.getTaskExecutions(taskId, page, (response) => {
            if (response.status === RESPONSE_STATUS.SUCCESS) {
                setExecutions(response.data.content);
                setTotalPages(response.data.totalPages);
            } else {
                Alert.warn(response.message);
            }
            setLoading(false);
        });
    }, [taskId, page]);

    useEffect(() => {
        fetchExecutions();
    }, [fetchExecutions]);

    return { executions, loading, refetch: fetchExecutions, page, setPage, totalPages };
}

export default useTaskExecutions;
